import { useEffect } from "react";

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };

    // Note: by default handler is a new ...
    // ... function on every render, so for the optimization ...
    // ... purposes you can wrap handler in useCallback before ...
    // ... passing it into this hook
  }, [ref, handler]);
};

export default useOnClickOutside;
